module.exports = __webpack_public_path__ + "img/pdf.3c22ab78.png";